const getParentOrCanonicalRoute = (parents, product) => {
    var _a;
    if ((parents === null || parents === void 0 ? void 0 : parents.length) > 0) {
        return parents;
    }
    else if ((_a = product === null || product === void 0 ? void 0 : product.primaryRoute) === null || _a === void 0 ? void 0 : _a.parents) {
        return product.primaryRoute.parents;
    }
    else {
        return null;
    }
};
export default getParentOrCanonicalRoute;
//# sourceMappingURL=getParentsOrCanonicalRoute.js.map